import { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';
export interface BorderedHeadlineProps {
  className?: string;
  containerClassName?: string;
  borderDirection?: 'bottom' | 'top';
  headlineText?: string;
}
const BorderedHeadline = ({
  children,
  className,
  containerClassName,
  borderDirection = 'top',
  headlineText
}: PropsWithChildren<BorderedHeadlineProps>) => {
  return <div className={twMerge('mx-auto my-8 grid w-full grid-cols-[minmax(20%,auto),minmax(auto,60%),minmax(20%,auto)] items-center gap-8 px-8', containerClassName)}>
      <div className={twMerge('h-14 bg-left bg-no-repeat opacity-20', borderDirection === 'top' ? '-translate-y-1/2 bg-[url(/assets/custom-borders/border-pointing-up.webp)]' : 'translate-y-1/2 bg-[url(/assets/custom-borders/border-pointing-down.webp)]')} />
      <div className={twMerge('text-center text-7xl font-bold uppercase', className)}>
        {children || headlineText}
      </div>
      <div className={twMerge('h-14 bg-right bg-no-repeat opacity-20', borderDirection === 'top' ? '-translate-y-1/2 bg-[url(/assets/custom-borders/border-pointing-up.webp)]' : 'translate-y-1/2 bg-[url(/assets/custom-borders/border-pointing-down.webp)]')} />
    </div>;
};
export default BorderedHeadline;